/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MediaRootPermissionAccessOptions,
    MediaRootPermissionAccessOptionsFromJSON,
    MediaRootPermissionAccessOptionsFromJSONTyped,
    MediaRootPermissionAccessOptionsToJSON,
} from './';

/**
 * 
 * @export
 * @interface MediaLibraryShareRequest
 */
export interface MediaLibraryShareRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof MediaLibraryShareRequest
     */
    bundles?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof MediaLibraryShareRequest
     */
    directories?: Array<number>;
    /**
     * 
     * @type {Date}
     * @memberof MediaLibraryShareRequest
     */
    expires: Date;
    /**
     * 
     * @type {number}
     * @memberof MediaLibraryShareRequest
     */
    viewLimit?: number | null;
    /**
     * 
     * @type {MediaRootPermissionAccessOptions}
     * @memberof MediaLibraryShareRequest
     */
    permissions: MediaRootPermissionAccessOptions;
    /**
     * 
     * @type {number}
     * @memberof MediaLibraryShareRequest
     */
    user?: number;
    /**
     * 
     * @type {string}
     * @memberof MediaLibraryShareRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaLibraryShareRequest
     */
    linkType?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaLibraryShareRequest
     */
    password?: string | null;
}

export function MediaLibraryShareRequestFromJSON(json: any): MediaLibraryShareRequest {
    return MediaLibraryShareRequestFromJSONTyped(json, false);
}

export function MediaLibraryShareRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaLibraryShareRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bundles': !exists(json, 'bundles') ? undefined : json['bundles'],
        'directories': !exists(json, 'directories') ? undefined : json['directories'],
        'expires': (new Date(json['expires'])),
        'viewLimit': !exists(json, 'view_limit') ? undefined : json['view_limit'],
        'permissions': MediaRootPermissionAccessOptionsFromJSON(json['permissions']),
        'user': !exists(json, 'user') ? undefined : json['user'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'linkType': !exists(json, 'link_type') ? undefined : json['link_type'],
        'password': !exists(json, 'password') ? undefined : json['password'],
    };
}

export function MediaLibraryShareRequestToJSON(value?: MediaLibraryShareRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bundles': value.bundles,
        'directories': value.directories,
        'expires': (value.expires.toISOString()),
        'view_limit': value.viewLimit,
        'permissions': MediaRootPermissionAccessOptionsToJSON(value.permissions),
        'user': value.user,
        'email': value.email,
        'link_type': value.linkType,
        'password': value.password,
    };
}


